import axiosInstance from "../../interceptor/intercetptor-inctence";

export const createPharmaDoctorAPI = (data) => {
	return axiosInstance.post(`/pharma/createPharmaDoctor`, data);
};

export const getPharmaDoctorAPI = (data) => {
	return axiosInstance.post(`/pharma/getPharmaDoctor`, data);
};

export const updatePharmaDoctorAPI = (data) => {
	return axiosInstance.post(`/pharma/updatePharmaDoctor`, data);
};

export const deletePharmaDoctorAPI = (data) => {
	return axiosInstance.post(`/pharma/deletePharmaDoctor`, data);
};

export const masterPharmaDoctorsAPI = (data) => {
	return axiosInstance.post(`/pharma/masterPharmaDoctors`, data);
};

export const updatePharmaDoctorStatusAPI = (data) => {
	return axiosInstance.post(`/pharma/updatePharmaDoctorStatus`, data);
};

export const pharmaDoctorListAPI = (data) => {
	return axiosInstance.post(`/pharma/pharmaDoctorList`, data);
};

export const exportPharmaDoctorsAPI = (data = {}) => {
	return axiosInstance.post(`/pharma/exportPharmaDoctors`, data);
};

export const importPharmaDoctorsAPI = (data) => {
	return axiosInstance.post(`/pharma/importPharmaDoctors`, data);
};
